



















import { FileHeader } from "@/domain/file";
import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import FileUploadDialog from "./FileUploadDialog.vue";
import FileTableSelector from "./FileTableSelector.vue";
import FileListMixin from "./mixins/FileListMixin.vue";
import Enumerable from "linq";

@Component({
  components: {
    FileUploadDialog,
    FileTableSelector,
  }
})
export default class FileListView extends Mixins(FileListMixin) {
  @Prop()
  folderGuid: string;

  data() {
    return {
      selectedFiles: [] as FileHeader[],
      files: [] as FileHeader[],
      isDialogVisible: false,
    };
  }
  selectedFiles: FileHeader[];
  files: FileHeader[];
  isDialogVisible: boolean;

  $refs!: {
    downLoadFiles: HTMLDivElement,
  };

  mounted() {
    if (this.folderGuid) {
      this.updateFileList(this.folderGuid);
    }
  }

  get downloadEnable(): boolean {
    return (0 < this.selectedFiles.length) && (this.selectedFiles.length < this.displaySetting.forceCompressionCount);
  }

  get deleteEnable(): boolean {
    return (0 < this.selectedFiles.length)
      && (!!this.$store.getters.user || Enumerable.from(this.selectedFiles).all(f => !f.createUserCode));
  }

  get downloadWarningMessageEnable(): boolean {
    return (this.displaySetting.forceCompressionCount <= this.selectedFiles.length);
  }

  get downloadWarningMessage(): string {
    return "※" + this.displaySetting.forceCompressionCount + "件以上のファイルをダウンロードする場合は全ファイルダウンロードをしてください。"
  }

  @Watch("folderGuid")
  onFolderGuidUpdated(newValue: string, oldValue: string): void {
    if (!newValue) {
      this.files = [];
      return;
    }
    this.updateFileList(newValue);
  }

  private updateFileList(folderGuid: string): void {
    this.getFileList(folderGuid).then(f => this.files = f);
  }

  @Watch("files")
  onFilesUpdated(newValue: FileHeader[], oldValue: FileHeader[]): void {
    this.selectedFiles = [];
  }

  
  get warningMessageEnable() : boolean {
    return !this.$store.getters.user;
  }
  

  selectionChanged(value: FileHeader[]): void {
    this.selectedFiles = value;
  }

  async downLoadFile(): Promise<void> {
    for (const c of this.$refs.downLoadFiles.childNodes) {
      (c as HTMLAnchorElement).click();
    }
  }

  async downloadBatchFiles(): Promise<void> {
    this.downloadFiles(this.folderGuid);
  }

  addFile(): void {
    this.isDialogVisible = true;
  }

  uploadConfirm(): void {
    this.updateFileList(this.folderGuid);
    this.filesChanged();
  }

  deleteSelectedFile(): void {
    this.$confirm("削除してもよろしいですか？", "ファイル削除", { confirmButtonText: "削除", cancelButtonText: "取消" })
    .then(async () => {
      for (const file of this.selectedFiles) {
        if (!(await this.deleteFile(this.folderGuid, file.id))) {
          break;
        }
      }
      this.updateFileList(this.folderGuid);
      this.filesChanged();
    })
    .catch(() => {});
  }

  @Emit()
  filesChanged(): void {}
}
